export const categoryStyles = {
  Kunde: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
  Interessent: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
  Lieferant: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400"
};

const RECENT_CUSTOMERS_KEY = "recent_customer_ids";
const RECENT_LIMIT = 5;

export function getRecentCustomerIds() {
  try {
    const raw = localStorage.getItem(RECENT_CUSTOMERS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function pushRecentCustomerId(id) {
  if (!id) return;
  try {
    const current = getRecentCustomerIds().filter((x) => x !== id);
    current.unshift(id);
    localStorage.setItem(RECENT_CUSTOMERS_KEY, JSON.stringify(current.slice(0, RECENT_LIMIT)));
  } catch {
    // Silent
  }
}
